module.exports = __webpack_public_path__ + "static/media/sap-b1.e462b250.png";